import React from 'react';
import { Button as ThemeButton } from 'theme-ui';

import type { ButtonProps as ThemeButtonProps } from 'theme-ui';

type ButtonProps = ThemeButtonProps;

const Button = (props : ButtonProps) => {
    return <ThemeButton {...{type: "button", ...props}} />
};

export default Button;
